import React from 'react'
import {Button} from 'components/common'

class Log extends React.Component {
	constructor(props) {
		super(props);
		this.actions = {1: 'insert', 2: 'update', 3: 'delete'};
	}

	renderJson(json) {
		const items = Object.keys(json).map(key => {
			const row = json[key]
			return (
				<tr key={key}>
					<td>{key}</td>
					<td>{row instanceof Object ? this.renderJson(row) : row}</td>
				</tr>
			)
		})
		return (
			<table className="table min alternate">
				<tbody>
					{items}
				</tbody>
			</table>
		)
	}

	onExpand(log, is_expanded) {
		log.expanded = is_expanded == 1 ? 0 : 1;
		this.forceUpdate();
	}

	render() {
		const data = this.props.data.map(log => {
			const row = log.expanded ? this.renderJson(log.data) : log.placeholder;
			return (
				<tr key={log.id}>
					<td className="pointer"><em className={log.expanded ? 'la la-minus' : 'la la-plus'} onClick={() => this.onExpand(log, log.expanded == 1)} /></td>
					<td>{log.id}</td>
					<td>{this.actions[log.action]}</td>
					<td>{row}</td>
					<td title={log.name}>{log.username}</td>
					<td>{log.created_at}</td>
				</tr>)
		});
		
		return (
			<div>
				<table className="table regular_table_grid">
					<thead>
						<tr>
							<th></th>
							<th>Id.</th>
							<th className="left">Operação</th>
							<th className="left">Dados</th>
							<th className="left">Utilizador</th>
							<th className="left">Data</th>
						</tr>
					</thead>
					<tbody>
						{data}
					</tbody>
				</table>
			</div>
		);
	}
}

export const buttonLog = (model, id, classn = null) => (
	<a key={'_log' + id} title='ver logs' className={classn} onClick={() => { LogDialog(model, id) }}>
		<em className="la la-history" />
	</a>)

export const LogDialog = (model, id) => {
	http.get('/log/get.json', {
		model: model,
		id: id
	}, (response, success) => {
		if (success) {
			response.data.forEach(row => {
				row.placeholder = row.data.substring(0, 60) + '...';
				row.data = JSON.parse(row.data);
			});
			mbox.modal(
				<Log
					model={model}
					id={id}
					data={response.data}
				/>, {
				title: 'Log [' + model + '] :: ' + id,
				buttons: ['close']
			});
		}
	});
}
